export { default } from './top-menu.component';